import AbstractBulkDataParser from '../../../../vendor_core/core/src/server/parsers/AbstractBulkDataParser';
import { IBaseDataParser } from '../../../../vendor_core/core/src/server/parsers/IBaseDataParser';
import SymbolMap from '../../../../vendor_core/core/src/utils/SymbolMap';
import { IBBData } from '../../model/IBBData';
import Utils from '../../../../vendor_core/core/src/utils/Utils';
import ILoginData from '../data/ILoginData';
import { ISpinResponseData } from '../data/ISpinResponseData';
// import * as test from "./resp.json"


export default class BBMultipliersParser  extends AbstractBulkDataParser<any> {
    validateData(data: any): boolean {
        return (data.generations || data.refresh) && data.stats;
    }
    processData(source: any) {
        // source = test;
        let data: ISpinResponseData;
        let recoverData = null;
        let results = [];
        if (source.hasOwnProperty("refresh")) {
            data = (source as ILoginData).refresh;
            if (data.restoreState) {
                recoverData = JSON.parse(data.restoreState);
            }
        } else {
            data = source as ISpinResponseData;
        }

        // let spindata: IPlayData = data;

        let currentGenerationIndex = recoverData ? recoverData.generation : 0;

        if (currentGenerationIndex >= data.generations.length) {
            currentGenerationIndex = data.generations.length - 1;
        }
        const generationsData = this.parseGenerationsSymbolsData(
            Utils.deepClone(data.generations)
        );
        const currentSlice = generationsData.slice(currentGenerationIndex);
        let cascadesData: any[] = this.parseCascadeSpins(
            currentSlice
        );

        let d = {
            cascades: cascadesData.slice(0, generationsData.length - 1),
            multipliersAfter: generationsData[generationsData.length - 1].multiplierAfter,
            multipliersBefore: generationsData[generationsData.length - 1].multiplierBefore,
        };
        results.push(d);
        if (data.freespins) {

            data.freespins.forEach((spinData, index) => {
                const generationsData = this.parseGenerationsSymbolsData(
                    Utils.deepClone(spinData.generations)
                );
                const currentSlice = generationsData.slice(currentGenerationIndex);
                let cascadesData: any[] = this.parseCascadeSpins(currentSlice)
                let d = {
                    cascades: cascadesData.slice(0, generationsData.length - 1),
                    multipliersAfter: generationsData[generationsData.length - 1].multiplierAfter,
                    multipliersBefore: generationsData[generationsData.length - 1].multiplierBefore,
                };

                results.push(d);
            });

        }
        // debugger
        // console.log("[BBMultipliersParser] result", results);

        return results;
    }


    parseGenerationsSymbolsData(generationData): any[] {
        let i: number;
        const genDataLen = generationData.length;
        for (i = 0; i < genDataLen; i++) {
            generationData[i].index = i;
            generationData[i].ended = i === genDataLen - 1;
            generationData[i].removedSymbols = Utils.deepClone(generationData[i].destroyedXPositions);
            generationData[i].symbols = generationData[i].symbols

            generationData[i].multiplierAfter = generationData[i].multiplierAfter
            generationData[i].multiplierBefore = generationData[i].multiplierBefore
            generationData[i].originalSymbols =
                generationData[i].originalSymbols

            // generationData[i].symbols.forEach( reel =>{
            //     reel.push(0);
            //     reel.unshift(0);
            // })
            generationData[i].generationWin = this.calculateGenWin(
                generationData[i].winnings
            );
            generationData[i].transformation = generationData[i].transform
        }
        return generationData;
    }

    calculateGenWin(winData) {
        let winning = 0;
        for (let i = 0; i < winData.length; i++) {
            if (winData[i][0] != "freespins") {
                winning += winData[i][2];
            }
        }
        return winning;
    }

    parseCascadeSpins(cascadeSpins: any): any[] {
        if (!cascadeSpins) {
            return [];
        }

        if (cascadeSpins.length === 1) {
            return [];
        }


        // If single item - convert to 1-item array for easier parsing
        if (!Array.isArray(cascadeSpins)) {
            cascadeSpins = [cascadeSpins];
        }

        let cascades = [];

        cascadeSpins.forEach((cascade, index) => {
            let parsedCascade = this.parseCascadeObject(cascade);
            cascades.push(parsedCascade);
        });

        return cascades;
    }

    parseCascadeObject(cascade): any {
        const result = {
            transform: cascade.transform,
            multiplier: cascade.multiplier,
            multiplierBefore: cascade.multiplierBefore,
            multiplierAfter: cascade.multiplierAfter,
            symbols: cascade.symbols
        };

        //console.log(result);
        // debugger
        return result;

    }
}
